import { useEffect } from "react";

const RedirectIg = () => {
  useEffect(() => {
    window.location.href =
      "https://takyon.io/?utm_source=ig&utm_medium=organic";
  }, []);
  return null;
};

export default RedirectIg;
